import { Expose } from 'class-transformer';

export class ServiceDescriptionDto {
  @Expose()
  uuid: string;

  @Expose()
  description: string;
}
